import {Store} from "vuex";
import { TableHelperInterface } from '@common/table/interfaces/TableHelper';
import {TableColumn} from "@common/table/interfaces/TableColumn";
import {FilterSetting} from "@common/table/interfaces/FilterSetting";
import { CancelTokenSource } from "axios";

export abstract class AbstractTableHelper implements TableHelperInterface {
    cancelToken: CancelTokenSource | null = null;
    list: Record<string, any>;
    page = 1;
    take = 20;
    count = 0;
    searchStr = '';
    isLoading = false;
    filterOrder = "createdAt";
    filterDirection: "asc" | "desc" = "desc";
    sortOnClient = false;
    ticketType: string;
    filters: { [key: string]: any } = {};
    searchableFields: string[] = ['title'];

    constructor(readonly store: Store<any>) {}

    abstract getList(): void;
    abstract getFilterList(): Promise<FilterSetting[]>;
    abstract getTableColumns(): TableColumn[];

    filterDuplicates(data: any[]) {
        const clonedData = [...data];
        const currentItemIds = this.list.map((item: { [key: string]: any }) => item.id);
        return clonedData.filter(item => currentItemIds.indexOf(item.id) < 0);
    }

    getOrderSettings(direction: "asc" | "desc" = "asc", manualOrder: string) {
        const order: any[] = [];

        order.push({
            column: manualOrder,
            direction: direction
        });

        return order.length > 0 ? [...order] : null;
    }

    prepareFilter(params: { [key: string]: any }) {
        const parts: string[] = params.searchStr.split(' ');
        const result: any[] = [];

        const filter: any[] = [];
        parts.forEach((part) => {
            this.searchableFields.forEach((field) => {
                let obj: { [key: string]: any } = {}
                obj[field] = {
                    $regex: `(?i).*${part}.*`
                };
                filter.push(obj)
            });
        });

        result.push({
            $or: [
                ...filter
            ]
        });

        return {$and: result}
    }

    async sortList() {
        this.list = this.list.sort((a: { [key: string]: any }, b: { [key: string]: any }) => {
            if (a[this.filterOrder] > b[this.filterOrder]) {
                return this.filterDirection == "asc" ? 1 : -1;
            }

            if (a[this.filterOrder] < b[this.filterOrder]) {
                return this.filterDirection == "asc" ? -1 : 1;
            }

            return 0;
        });
    }

    resetSorting() {
        this.filterOrder = "createdAt";
        this.filterDirection = "desc";
    }

    getRequestQuery(include: string[] | Record<string, any>, usePagging = true) {
        return {};
    }
}
